import { render } from "./tm-count.vue?vue&type=template&id=126701d9&scoped=true"
import script from "./tm-count.vue?vue&type=script&lang=js"
export * from "./tm-count.vue?vue&type=script&lang=js"

import "./tm-count.vue?vue&type=style&index=0&id=126701d9&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126701d9"]])

export default __exports__